export default __webpack_public_path__ + "static/media/IndiaSoft2025-Skyniche 3 1-1.047a1fa3.png";